import { view } from '@yola/ws-sdk';
import combineBatches from './combine-batches';

const getElementAttributeValue = (elementId, attribute) => {
  const hasAttribute = view.verifiers.hasElementAttribute(elementId, attribute);

  return hasAttribute ? view.accessors.getElementAttribute(elementId, attribute) || true : false;
};

const generateInitialState = (settings) => {
  const batches = settings.map(({ elementIds = [], attributes = [] }) => {
    const batch = {};

    elementIds.forEach((elementId) => {
      attributes.forEach((attribute) => {
        const value = getElementAttributeValue(elementId, attribute);

        if (!batch[elementId]) {
          batch[elementId] = {};
        }

        batch[elementId][attribute] = value;
      });
    });

    return batch;
  });

  return combineBatches(batches);
};

export default generateInitialState;
